import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/park';

export class ParkService extends RestServiceConnection {


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE PARQUES EÓLICOS
     * @EN GETS THE LIST OF WIND FARMS
     */
    // -------------------------------------------------------------------------------------------------------------
    listParks = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UN PARQUE EÓLICO POR SU ID
     * @EN GETS A WIND FARM BY ITS ID
     * 
     * @param parkId
     */
    // -------------------------------------------------------------------------------------------------------------
    getParkById = async (parkId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { 
                id: parkId 
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE EL NÚMERO TOTAL DE PARQUES EÓLICOS
     * @EN GETS THE TOTAL NUMBER OF WIND FARMS
     */
    // -------------------------------------------------------------------------------------------------------------
    getTotalWindFarms = async () => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get-total-parks',
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREA UN PARQUE EÓLICO
     * @EN CREATES A WIND FARM
     * 
     * @param park
     */
    // -------------------------------------------------------------------------------------------------------------
    createPark = async (park: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: park,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ACTUALIZA UN PARQUE EÓLICO
     * @EN UPDATES A WIND FARM
     * 
     * @param park
     */
    // -------------------------------------------------------------------------------------------------------------
    editPark = async (park: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: park,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UN PARQUE EÓLICO
     * @EN DELETES A WIND FARM
     * 
     * @param parkId
     */
    // -------------------------------------------------------------------------------------------------------------
    deletePark = async (parkId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { 
                id: parkId 
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA TODOS LOS PARQUES EÓLICOS SELECCIONADOS
     * @EN DELETES ALL SELECTED WIND FARMS
     * 
     * @param parksIds
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteMultiPark = async (parksId: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multi',
            data: { 
                parksId: parksId
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CAMBIA EL ESTADO DE UN PARQUE EÓLICO
     * @EN CHANGES THE STATUS OF A WIND FARM
     * 
     * @param parkId
     */
    // -------------------------------------------------------------------------------------------------------------
    toggleStatus = async (parkId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle',
            data: { 
                id: parkId
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------
    
    //--------------------------------------------------------------------------------------------------------
    /**
     * @ES AGREGAR COORDINADORES A UN PARQUE
     * @EN ADD COORDINATORS TO A PARK
     * 
     * @param id
     * @param users
     * 
     */
    //--------------------------------------------------------------------------------------------------------
    addUsersToPark = async (id:string, users: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/add-user-to-park',
            data: { 
                id: id,
                users: users
            },
        }, true);
        return this;
    }
    //--------------------------------------------------------------------------------------------------------



    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE PARQUES EÓLICOS
     * @EN GETS THE LIST OF WIND FARMS
     */
    // -------------------------------------------------------------------------------------------------------------
    listForSelect = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-select',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------
}